import React from "react";
import PropTypes from "prop-types";
import HtmlTooltip from "./HtmlTooltip";
import ColourConstants from "helpers/colourConstants";

// A tooltip-column cell shows the value both as text and, on hover, in a
// tooltip synced to the current DOM content (see useCellTooltipSync) -
// "notes" specifically renders as HTML rather than plain text either way.
const TooltipCell = ({ col, value, toggle, onTooltipOpen }) => (
	<HtmlTooltip
		id={`tooltip-${col}`}
		title={col === "notes" ? <div dangerouslySetInnerHTML={{ __html: value }} /> : value}
		onOpen={onTooltipOpen}
	>
		<p
			className="max-two-line"
			style={{ color: toggle ? ColourConstants.tableRowNormal : "" }}
			draggable="true"
			{...(col === "notes" && { dangerouslySetInnerHTML: { __html: value } })}
		>
			{col === "notes" ? null : value}
		</p>
	</HtmlTooltip>
);

TooltipCell.propTypes = {
	col: PropTypes.string.isRequired,
	value: PropTypes.node,
	toggle: PropTypes.bool.isRequired,
	onTooltipOpen: PropTypes.func,
};

export default TooltipCell;
